import DefaultCard from "../components/DefaultCard";

export const DataProjectsM = [
  [
    {
      tab_one: {
        id: 1001,
        objeto: {
          projectTitle: "Pokedex App",
          briefDescription:
            "This project was created as a tool for Pokémon fans and curious developers. Check out data, explore Pokémon, and learn about them! All the content is educational.",
          url_video:
            "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2Fvideos%2F_video_pokedex_web.mp4?alt=media&token=4726635d-1f24-46b8-9a8b-1afe46ccee8f",
        },
      },
      tab_two: {
        id: 1002,
        objeto: {
          firstScreenShot:
            "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2Fscreens%2Ffirst-ss-one.jpg?alt=media&token=56619d2e-90c0-4017-9668-db95f6b3df4b",
          secondScreenShot:
            "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2Fscreens%2Ffirst-ss-two.jpg?alt=media&token=4f47cb95-1dbb-47cd-a927-8cb4c157bbee",
          gitRepo: "https://github.com/bornsrss14/panda-pokedex",
        },
      },
      tab_three: {
        id: 1003,
        objeto: { componente: <DefaultCard></DefaultCard> },
      },
    },
  ],
  [
    {
      tab_one: {
        id: 1001,
        objeto: {
          projectTitle: "Notaria 9: Landing Page",
          briefDescription:
            "A responsive and user-friendly landing page for Notary 9. Featuring a dynamic openign hours display and basic SEO-optimized structure",
          url_video:
            "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2Fvideos%2F_video_notaria_web.mp4?alt=media&token=0cd57915-d45a-4586-94c2-243cde5e6c26",
        },
      },
      tab_two: {
        id: 1002,
        objeto: {
          firstScreenShot:
            "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2Fscreens%2Fsecond-ss-one.jpg?alt=media&token=e38f49ab-5da4-4e64-98cc-78a82282bc3e",
          secondScreenShot:
            "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2Fscreens%2Fsecond-ss-two.jpg?alt=media&token=5647ca0b-d628-440c-8dd3-6c84fe44344f",
          gitRepo: "https://github.com/bornsrss14/notaria-nueve",
        },
      },
      tab_three: {
        id: 1003,
        objeto: { componente: <DefaultCard></DefaultCard> },
      },
    },
  ],
  [
    {
      tab_one: {
        id: 1001,
        objeto: {
          projectTitle: "MUBI:: Rate movies and share reviews",
          briefDescription:
            "My latest project: A social network web app to review movies and series, create watch list, save favorites and interact with other users in comment sections in each review. It's not full coded, please, stay tune!",
          url_video:
            "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2Fvideos%2F_video_dos.mp4?alt=media&token=bdef8375-95fb-4bdd-95f0-ff409f64b275",
        },
      },
      tab_two: {
        id: 1002,
        objeto: {
          firstScreenShot:
            "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2Fscreens%2FCaptura%20de%20pantalla%202025-10-30%20-%2002.20.17.png?alt=media&token=36c1a189-5c94-42b4-b886-d40e0b07d815",
          secondScreenShot:
            "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2Fscreens%2F_segunda_captura_mubi.png?alt=media&token=58422658-4ee2-44ed-be59-025109e6fcf8",
          gitRepo: "https://github.com/bornsrss14/mubi_pandas",
        },
      },
      tab_three: {
        id: 1003,
        objeto: { componente: <DefaultCard></DefaultCard> },
      },
    },
  ],
  [
    {
      tab_one: {
        id: 1001,
        objeto: {
          projectTitle: "Hiking Map",
          briefDescription:
            "This app uses leaflet maps to allow users to interactively place pins, whether traveling by bike or on foot. Also put in practice user experience principles throughout the design.",
          url_video:
            "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2Fscreens%2Fvideo-mapas-leaflet.mp4?alt=media&token=3945d143-2274-447e-a8f2-4448d3666c1c",
        },
      },
      tab_two: {
        id: 1002,
        objeto: {
          firstScreenShot:
            "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2Fscreens%2Ffourth-ss-one.png?alt=media&token=2021a199-73e4-47ac-a3d5-aaece3630702",
          secondScreenShot:
            "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2Fscreens%2Ffourth-ss-two.png?alt=media&token=e368e161-cfc2-455a-93bb-da3bd48f8566",
          gitRepo:
            "https://github.com/bornsrss14/fundamentalsJavaScript/tree/master",
        },
      },
      tab_three: {
        id: 1003,
        objeto: { componente: <DefaultCard></DefaultCard> },
      },
    },
  ],
  [
    {
      tab_one: {
        id: 1001,
        objeto: {
          projectTitle: "Split the Bill",
          briefDescription:
            "Web to help you split a bill or receipt with your friend. Easily figure out who owes you what, based on what they paid.",
          url_video: null,
        },
      },
      tab_two: {
        id: 1002,
        objeto: {
          firstScreenShot:
            "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2Fscreens%2Ffive-ss-one.png?alt=media&token=4bdb7646-a15c-4edd-8f43-8a9881fd664e",
          secondScreenShot:
            "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2Fscreens%2Ffive-ss-two.png?alt=media&token=3e7e07dd-9995-49fb-bb35-f3cfaa2fe0c2",
          gitRepo: "https://github.com/bornsrss14/money-together",
        },
      },
      tab_three: {
        id: 1003,
        objeto: { componente: <DefaultCard></DefaultCard> },
      },
    },
  ],
  [
    {
      tab_one: {
        id: 1001,
        objeto: {
          projectTitle: "To-Do list",
          briefDescription:
            "To-Do list project is a practice focused on state management across components. It demostrates lifting state up to share data between components.",
          url_video:
            "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2Fscreens%2Flista-video.mp4?alt=media&token=0bd89d69-8069-4f2f-8ae1-fe655c87da04",
        },
      },
      tab_two: {
        id: 1002,
        objeto: {
          firstScreenShot:
            "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2Fscreens%2Fsix-ss-two.png?alt=media&token=946fc029-5296-49e5-9f7b-32491c34aace",
          secondScreenShot:
            "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2Fscreens%2Fsix-ss-one.png?alt=media&token=41e13307-e5ad-4096-b032-f31538bd4d74",
          gitRepo: "https://github.com/bornsrss14/pandas-todo-list",
        },
      },
      tab_three: {
        id: 1003,
        objeto: { componente: <DefaultCard></DefaultCard> },
      },
    },
  ],
];
export const DataProjectsMobile = [
  {
    tab_one: {
      id: 1001,
      objeto: {
        projectTitle: "Pokedex App",
        briefDescription:
          "This project was created as a tool for Pokémon fans and curious developers. Check out data, explore Pokémon, and learn about them! All the content is educational.",
        url_video:
          "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2Fvideos%2F_video_pokedex_web.mp4?alt=media&token=4726635d-1f24-46b8-9a8b-1afe46ccee8f",
        gitRepo: "https://github.com/bornsrss14/panda-pokedex",
        liveDemo: "https://pokedex-pandasneezing.netlify.app/",
      },
    },
    tab_two: {
      id: 1002,
      objeto: {
        firstScreenShot:
          "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2Fscreens%2Ffirst-ss-one.jpg?alt=media&token=56619d2e-90c0-4017-9668-db95f6b3df4b",
        secondScreenShot:
          "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2Fscreens%2Ffirst-ss-two.jpg?alt=media&token=4f47cb95-1dbb-47cd-a927-8cb4c157bbee",
      },
    },
    tab_three: {
      id: 1003,
      objeto: {
        techStack:
          "React • Node.js • MySQL • AWS RDS • REST API • ResponsiveDesign",
        features: [
          "Built interactive Pokémon encyclopedia consuming REST API data for 1,000+ entries with real-time stats",
          "Engineered infinite scroll with lazy loading, reducing initial load time",
          "Implemented debounced search and multi-criteria filtering (name, type, generation) for enhanced UX",
          "Created mobile-first responsive design achieving consistent UX across all devices",
          "Developed custom React hooks for state management, cutting code redundancy",
        ],
      },
    },
  },
  {
    tab_one: {
      id: 1001,
      objeto: {
        projectTitle: "Notaria 9: Landing Page",
        briefDescription:
          "A responsive and user-friendly landing page for Notary 9. Featuring a dynamic openign hours display and basic SEO-optimized structure",
        url_video:
          "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2Fvideos%2F_video_notaria_web.mp4?alt=media&token=0cd57915-d45a-4586-94c2-243cde5e6c26",
        gitRepo: "https://github.com/bornsrss14/notaria-nueve",
        liveDemo:
          "https://notariacordoba.netlify.app/servicios/nuestros-servicios",
      },
    },
    tab_two: {
      id: 1002,
      objeto: {
        firstScreenShot:
          "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2Fscreens%2Fsecond-ss-one.jpg?alt=media&token=e38f49ab-5da4-4e64-98cc-78a82282bc3e",
        secondScreenShot:
          "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2Fscreens%2Fsecond-ss-two.jpg?alt=media&token=5647ca0b-d628-440c-8dd3-6c84fe44344f",
      },
    },
    tab_three: {
      id: 1003,
      objeto: {
        techStack:
          "React • JavaScript • CSS • React Router • Leaflet Maps • SEO Optimization",
        features: [
          "Developed modular landing page showcasing legal services and business information",
          "Built real-time open/closed status indicator based on business hours and holiday schedules",
          "Integrated interactive Leaflet map with custom markers, reducing direction inquiries by 45%",
          "Designed mobile-responsive interfaces and SEO-friendly content sections",
          "Optimized for SEO and accessibility, achieving 95+ Lighthouse performance scores",
        ],
      },
    },
  },
  {
    tab_one: {
      id: 1001,
      objeto: {
        projectTitle: "MUBI:: Rate movies and share reviews",
        briefDescription:
          "My latest project: A social network web app to review movies and series, create watch list, save favorites and interact with other users in comment sections in each review. It's not full coded, please, stay tune!",
        url_video:
          "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2Fvideos%2F_video_dos.mp4?alt=media&token=bdef8375-95fb-4bdd-95f0-ff409f64b275",
        gitRepo: "https://github.com/bornsrss14/mubi_pandas",
        liveDemo: "https://mubipandas.rosfuentes.dev/",
      },
    },
    tab_two: {
      id: 1002,
      objeto: {
        firstScreenShot:
          "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2Fscreens%2FCaptura%20de%20pantalla%202025-10-30%20-%2002.20.17.png?alt=media&token=36c1a189-5c94-42b4-b886-d40e0b07d815",
        secondScreenShot:
          "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2Fscreens%2F_segunda_captura_mubi.png?alt=media&token=58422658-4ee2-44ed-be59-025109e6fcf8",
      },
    },
    tab_three: {
      id: 1003,
      objeto: {
        techStack:
          "React • Node.js • MySQL • AWS RDS • REST API • Responsive Design",
        features: [
          "search films, curate favorites, write reviews, and engage through comments and reactions.",
          "Architected RESTful API integration with TMDB database, implementing efficient data fetching",
          "Developed responsive, mobile-first UI components using React and modern CSS",
          "Designed and deployed MySQL database schema on AWS RDS with normalized tables for users",
          "Implemented lazy loading and image compression strategies for heavy media assets, significantly enhancing application performance and user experience",
        ],
      },
    },
  },
  {
    tab_one: {
      id: 1001,
      objeto: {
        projectTitle: "Hiking Map",
        briefDescription:
          "This app uses leaflet maps to allow users to interactively place pins, whether traveling by bike or on foot. Also put in practice user experience principles throughout the design.",
        url_video:
          "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2Fscreens%2Fvideo-mapas-leaflet.mp4?alt=media&token=3945d143-2274-447e-a8f2-4448d3666c1c",
        gitRepo:
          "https://github.com/bornsrss14/fundamentalsJavaScript/tree/master",
        liveDemo: "https://fundamentalsjavascript.onrender.com/",
      },
    },
    tab_two: {
      id: 1002,
      objeto: {
        firstScreenShot:
          "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2Fscreens%2Ffourth-ss-one.png?alt=media&token=2021a199-73e4-47ac-a3d5-aaece3630702",
        secondScreenShot:
          "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2Fscreens%2Ffourth-ss-two.png?alt=media&token=e368e161-cfc2-455a-93bb-da3bd48f8566",
      },
    },
    tab_three: {
      id: 1003,
      objeto: {
        techStack: "",
        features: [],
      },
    },
  },
  {
    tab_one: {
      id: 1001,
      objeto: {
        projectTitle: "Split the Bill",
        briefDescription:
          "Web to help you split a bill or receipt with your friend. Easily figure out who owes you what, based on what they paid.",
        url_video: null,
        gitRepo: "https://github.com/bornsrss14/money-together",
        liveDemo: "https://moneytogether.rosfuentes.dev/",
      },
    },
    tab_two: {
      id: 1002,
      objeto: {
        firstScreenShot:
          "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2Fscreens%2Ffive-ss-one.png?alt=media&token=4bdb7646-a15c-4edd-8f43-8a9881fd664e",
        secondScreenShot:
          "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2Fscreens%2Ffive-ss-two.png?alt=media&token=3e7e07dd-9995-49fb-bb35-f3cfaa2fe0c2",
      },
    },
    tab_three: {
      id: 1003,
      objeto: {
        techStack: "",
        features: [],
      },
    },
  },
  {
    tab_one: {
      id: 1001,
      objeto: {
        projectTitle: "To-Do list",
        briefDescription:
          "To-Do list project is a practice focused on state management across components. It demostrates lifting state up to share data between components.",
        url_video:
          "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2Fscreens%2Flista-video.mp4?alt=media&token=0bd89d69-8069-4f2f-8ae1-fe655c87da04",
        gitRepo: "https://github.com/bornsrss14/pandas-todo-list",
        liveDemo: "https://todo-pandas.rosfuentes.dev/",
      },
    },
    tab_two: {
      id: 1002,
      objeto: {
        firstScreenShot:
          "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2Fscreens%2Fsix-ss-two.png?alt=media&token=946fc029-5296-49e5-9f7b-32491c34aace",
        secondScreenShot:
          "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2Fscreens%2Fsix-ss-one.png?alt=media&token=41e13307-e5ad-4096-b032-f31538bd4d74",
      },
    },
    tab_three: {
      id: 1003,
      objeto: {
        techStack: " React • TailwindCSS • LocalStorage • State Management",
        features: [
          "Built CRUD to-do application with task completion tracking and priority management",
          "Implemented LocalStorage persistence for seamless data retention across browser sessions",
          "Developed React component architecture with custom hooks for state management",
          "Filter: All tasks, Active, Completed",
        ],
      },
    },
  },
];

const DataProjects = [
  {
    id: 1003,
    projectTitle: "Pokedex App",
    briefDescription:
      "This project was created as a tool for Pokémon fans and curious developers. Check out data, explore Pokémon, and learn about them! All the content is educational.",
    url_video:
      "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2Fvideos%2F_video_pokedex_web.mp4?alt=media&token=4726635d-1f24-46b8-9a8b-1afe46ccee8f",
    firstScreenShot:
      "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2Fscreens%2Ffirst-ss-one.jpg?alt=media&token=56619d2e-90c0-4017-9668-db95f6b3df4b",
    secondScreenShot:
      "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2Fscreens%2Ffirst-ss-two.jpg?alt=media&token=4f47cb95-1dbb-47cd-a927-8cb4c157bbee",
    gitRepo: "https://github.com/bornsrss14/panda-pokedex",
    liveDemo: "https://pokedex-pandasneezing.netlify.app/",
  },
  {
    id: 1002,
    projectTitle: "Notaria 9: Landing Page",
    briefDescription:
      "A responsive and user-friendly landing page for Notary 9. Featuring a dynamic openign hours display and basic SEO-optimized structure",
    url_video:
      "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2Fvideos%2F_video_notaria_web.mp4?alt=media&token=0cd57915-d45a-4586-94c2-243cde5e6c26",
    firstScreenShot:
      "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2Fscreens%2Fsecond-ss-one.jpg?alt=media&token=e38f49ab-5da4-4e64-98cc-78a82282bc3e",
    secondScreenShot:
      "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2Fscreens%2Fsecond-ss-two.jpg?alt=media&token=5647ca0b-d628-440c-8dd3-6c84fe44344f",
    gitRepo: "https://github.com/bornsrss14/notaria-nueve",
    liveDemo: "https://notariacordoba.netlify.app/servicios/nuestros-servicios",
  },
  {
    id: 1001,
    projectTitle: "MUBI:: Rate movies and share reviews",
    briefDescription: (
      <p>
        My latest project: A social network web app to{" "}
        <strong>review movies </strong>and series, create watch list, save
        favorites and <strong>interact with other users </strong> in comment
        sections in each review. It's not full coded, please, stay tune!
      </p>
    ),
    url_video:
      "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2Fvideos%2F_video_dos.mp4?alt=media&token=bdef8375-95fb-4bdd-95f0-ff409f64b275",
    firstScreenShot:
      "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2Fscreens%2FCaptura%20de%20pantalla%202025-10-30%20-%2002.20.17.png?alt=media&token=36c1a189-5c94-42b4-b886-d40e0b07d815",
    secondScreenShot:
      "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2Fscreens%2F_segunda_captura_mubi.png?alt=media&token=58422658-4ee2-44ed-be59-025109e6fcf8",
    gitRepo: "https://github.com/bornsrss14/mubi_pandas",
    liveDemo: "https://mubipandas.rosfuentes.dev/",
  },
  {
    id: 1004,
    projectTitle: "Hiking Map",
    briefDescription:
      "This app uses leaflet maps to allow users to interactively place pins, whether traveling by bike or on foot. Also put in practice user experience principles throughout the design.",
    url_video:
      "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2Fscreens%2Fvideo-mapas-leaflet.mp4?alt=media&token=3945d143-2274-447e-a8f2-4448d3666c1c",
    firstScreenShot:
      "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2Fscreens%2Ffourth-ss-one.png?alt=media&token=2021a199-73e4-47ac-a3d5-aaece3630702",
    secondScreenShot:
      "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2Fscreens%2Ffourth-ss-two.png?alt=media&token=e368e161-cfc2-455a-93bb-da3bd48f8566",
    gitRepo: "https://github.com/bornsrss14/fundamentalsJavaScript/tree/master",
    liveDemo: "https://fundamentalsjavascript.onrender.com/",
  },
  {
    id: 1005,
    projectTitle: "Split the Bill",
    briefDescription:
      "Web to help you split a bill or receipt with your friend. Easily figure out who owes you what, based on what they paid.",
    url_video: null,
    firstScreenShot:
      "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2Fscreens%2Ffive-ss-one.png?alt=media&token=4bdb7646-a15c-4edd-8f43-8a9881fd664e",
    secondScreenShot:
      "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2Fscreens%2Ffive-ss-two.png?alt=media&token=3e7e07dd-9995-49fb-bb35-f3cfaa2fe0c2",
    gitRepo: "https://github.com/bornsrss14/money-together",
    liveDemo: "https://moneytogether.rosfuentes.dev/",
  },
  {
    id: 1006,
    projectTitle: "To-Do list",
    briefDescription:
      "To-Do list project is a practice focused on state management across components. It demostrates lifting state up to share data between components.",
    url_video:
      "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2Fscreens%2Flista-video.mp4?alt=media&token=0bd89d69-8069-4f2f-8ae1-fe655c87da04",
    firstScreenShot:
      "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2Fscreens%2Fsix-ss-two.png?alt=media&token=946fc029-5296-49e5-9f7b-32491c34aace",
    secondScreenShot:
      "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/portfolio%2Fscreens%2Fsix-ss-one.png?alt=media&token=41e13307-e5ad-4096-b032-f31538bd4d74",
    gitRepo: "https://github.com/bornsrss14/pandas-todo-list",
    liveDemo: "https://todo-pandas.rosfuentes.dev/",
  },
];

export default DataProjects;
